// „+ Woche hinzufügen" und „+ Monat hinzufügen" — sitzen unter der Matrix
// und verlängern den `rangeEnd` der aktuellen Config. Der Wochentag-Filter
// bleibt unangetastet, sodass auch eine 4-Wochen-Erweiterung sinnvoll
// gefüllt bleibt.

import type { Store } from '../store';
import { el } from './dom';

function extendByDays(store: Store, days: number): void {
  const cur = store.get().config;
  const [y, m, d] = cur.rangeEnd.split('-').map(Number);
  const end = new Date(y, m - 1, d);
  end.setDate(end.getDate() + days);
  const yy = end.getFullYear();
  const mm = String(end.getMonth() + 1).padStart(2, '0');
  const dd = String(end.getDate()).padStart(2, '0');
  store.patchConfig({ rangeEnd: `${yy}-${mm}-${dd}` });
}

function extendByMonth(store: Store): void {
  const cur = store.get().config;
  const [y, m, d] = cur.rangeEnd.split('-').map(Number);
  const end = new Date(y, m - 1, d);
  end.setMonth(end.getMonth() + 1);
  const yy = end.getFullYear();
  const mm = String(end.getMonth() + 1).padStart(2, '0');
  const dd = String(end.getDate()).padStart(2, '0');
  store.patchConfig({ rangeEnd: `${yy}-${mm}-${dd}` });
}

export function renderRangeExtenders(store: Store): HTMLElement {
  const wrap = el('div', { class: 'salon-range-extenders', 'aria-label': 'Zeitraum verlängern' });
  const weekBtn = el('button',
    { type: 'button', class: 'salon-range-extender-btn', title: 'Range um 7 Tage verlängern' },
    '+ Woche hinzufügen',
  );
  weekBtn.addEventListener('click', () => extendByDays(store, 7));
  const monthBtn = el('button',
    { type: 'button', class: 'salon-range-extender-btn', title: 'Range um 1 Monat verlängern' },
    '+ Monat hinzufügen',
  );
  monthBtn.addEventListener('click', () => extendByMonth(store));
  wrap.append(weekBtn, monthBtn);
  return wrap;
}
